
const ReqType = {
  ping: 'ping',
  message: 'send_message',
  history: 'get_chat_history',
  userList: 'get_user_list',
  manual: 'set_manual_reply',
}

const RespType = {
  message: 'message',
  history: 'history',
  userList: 'userlist',
  statusChanged: 'statuschanged',
  error: 'error'
}

const Role = {
  user: 1,
  ai: 3,
  admin: 4,
  vmx: 5,
  agentInteract: 7,
}

const Subject = {
  text: 'text',
  script: 'script',
  subjectPushScript: 'pushscript'
}

const Status = {
  connected: 'connected',
  disconnected: 'disconnected',
  connecting: 'connecting',
  closed: 'closed',
  authRequired: 'auth_required'
}


export default {
  Status,
  ReqType,
  RespType,
  Role,
  Subject,
  /*
   * params: {
   *   "url": url,
   *   "onStatus": function(status) {},
   *   "onMessage": function(type, data) {}
   * }
   */
  create: function(_params) {
    let sock = null
    let status = Status.disconnected
    let params = {
      onStatus: _params['onStatus'] || function(status) {status},
      onMessage: _params['onMessage'] || function(type, data) {type, data},
      url: _params['url']
    }

    function statusChanged(new_status) {
      status = new_status
      try {
        params['onStatus'](status)
      } catch (e) {
        console.log(e)
      }
    }

    function connect() {
      if (sock !== null) {
        try {
          sock.close()
        } catch (e) {
          console.log(e)
        }
        sock = null
      }

      sock = new WebSocket(params['url'])
      statusChanged(Status.connecting)
      sock.onmessage = function(event) {
        try {
          let data = JSON.parse(event.data)
          params['onMessage'](data.type, data.data)
        } catch (e) {
          console.log(e)
        }
      }

      sock.onopen = function() {
        statusChanged(Status.connected)
      }

      sock.onerror = function() {
        statusChanged(Status.disconnected)
      }

      sock.onclose = function(e) {
        let status = Status.disconnected
        if (e.code === 4010) {
          status = Status.authRequired
        } else if (sock === null) {
          status = Status.closed
        }
        sock = null
        statusChanged(status)
      }
    }

    function wssend(type, data = {}) {
      if (status === Status.connected) {
        sock.send(JSON.stringify({ type, data }))
      }
    }

    let ping_wait = 30
    function check() {
      if (ping_wait-- == 0) {
        wssend(ReqType.ping)
        ping_wait = 30
      }

      if (status === Status.disconnected) {
        setTimeout(connect, 1)
      }

      if (status !== Status.closed && status !== Status.authRequired) {
        setTimeout(check, 1000)
      }
    }
    check()

    return {
      send: function(type, data = {}) {
        wssend(type, data)
      },
      close: function() {
        let tmp = sock
        sock = null
        if (tmp) {
          tmp.close()
        }
      }
    }
  }
}
